'use client';

import { isTjtSettings } from '../data/publicationIdentity';
import React, { useState } from 'react';

export default function NewsletterStrip({ siteSettings }) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) return;

    setStatus('loading');
    setErrorMessage('');

    try {
      const res = await fetch('/api/newsletter/subscribers', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      
      const data = await res.json();
      
      if (!res.ok) {
        throw new Error(data.error || 'Failed to subscribe');
      }
      
      setStatus('success');
      setEmail('');
    } catch (err) {
      setStatus('error');
      setErrorMessage(err.message);
    }
  };

  return (
    <div className="w-full font-sans mb-12">
      <div className="w-full border-t-2 border-b-2 border-black py-8 flex flex-col lg:flex-row items-center justify-between">
        
        {/* Left: Branding & Pitch */}
        <div className="flex flex-col md:flex-row items-center md:items-center flex-1 mb-6 lg:mb-0 text-center md:text-left w-full">
          
          <div className="flex flex-col md:pr-8 mb-4 md:mb-0 md:border-r border-gray-300">
            <span className="text-[11px] uppercase tracking-[0.25em] font-bold text-gray-500 mb-2">
              Subscribe to {isTjtSettings(siteSettings) ? "TJT" : siteSettings?.organization?.name || "our newsletter"}
            </span>
            <h3 className="text-3xl md:text-4xl font-black font-classic text-black leading-none tracking-tight">
              Newsletter
            </h3>
          </div>
          
          <div className="md:pl-8 flex items-center max-w-md w-full">
            <p className="text-[15px] text-gray-800 font-sans leading-relaxed">
              {status === 'success' ? (
                <span className="text-green-700 font-bold">Thank you! Your email has been added.</span>
              ) : status === 'error' ? (
                <span className="text-red-600 font-bold">{errorMessage}</span>
              ) : (
                `Get ${siteSettings?.organization?.name || "our publication"}' most talked-about news right in your inbox.`
              )}
            </p>
          </div>
        </div>
        
        {/* Right: Input & Button (Unified Form) */}
        <form onSubmit={handleSubmit} className="flex w-full lg:w-[420px] flex-shrink-0 border border-black focus-within:ring-1 focus-within:ring-black transition-shadow bg-white">
          <input 
            type="email" 
            placeholder="Your email address" 
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={status === 'loading' || status === 'success'}
            className="flex-1 px-5 py-3 text-[15px] font-sans outline-none bg-transparent placeholder-gray-500 text-black disabled:opacity-50"
            required
          />
          <button 
            type="submit"
            disabled={status === 'loading' || status === 'success'}
            className="bg-black text-white px-8 py-3 text-[12px] font-bold tracking-[0.15em] uppercase hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0"
          >
            {status === 'loading' ? 'WAIT' : 'SIGN UP'}
          </button>
        </form>

      </div>
    </div>
  );
}
